import { COMPLETE_TASK_REQUESTED,
    COMPLETE_TASK_RECEIVED,
    COMPLETE_TASK_ERROR,

    } from "../actions/bpmnComplete";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const completeTask = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case COMPLETE_TASK_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case COMPLETE_TASK_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.completeTask, action.receivedAt);
   case COMPLETE_TASK_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
